// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:host {
  display: block;
  width: 100%;
}
:host:not(:last-child) {
  margin-bottom: 10px;
}

.order-item {
  width: 100%;
  border-bottom: 1px solid #DCE8F5;
  padding: 14px 14px 20px;
}
.order-item .img_section {
  min-height: 75px;
  max-height: 100px;
}
.order-item .img_section .img_wrap {
  width: 100%;
  height: 100%;
}
.order-item .img_section .img_wrap:has(.default-img) {
  padding: 18px;
  --icon-color: var(--color-black);
}
.order-item .img_section ion-img {
  object-fit: contain;
  width: 90%;
  height: 90%;
  margin: 0 auto;
}
.order-item ion-col {
  padding: 0px !important;
}
.order-item .name-row {
  margin-bottom: 10px;
}
.order-item .order-article-name {
  color: #072633;
  font-family: BricolageGrotesque;
  font-size: 16px;
  line-height: 100%;
  letter-spacing: 2%;
  vertical-align: middle;
}
.order-item .article-price {
  font-family: AppFontBold;
  font-size: 16px;
  line-height: 120%;
  letter-spacing: 0.02em;
  vertical-align: middle;
  text-transform: uppercase;
}
.order-item .info-article-section .article-content {
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  padding: 0px 10px;
}

.icons_block {
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}

.edit_section {
  display: flex;
  justify-content: flex-end;
  align-items: center;
}
.edit_section ion-icon {
  height: 15px;
  width: 15px;
  margin: 0px 4px;
  cursor: pointer;
}

.flex-text {
  min-height: 30px;
}

.center-vertical {
  display: flex;
  align-items: center;
}

.option-group-name {
  font-family: AppFontBold;
  font-size: 10px;
  line-height: 120%;
  letter-spacing: 8%;
  vertical-align: middle;
  text-transform: uppercase;
  margin-bottom: 5px;
}

.option-name {
  font-family: AppFont;
  font-size: 10px;
  line-height: 120%;
  letter-spacing: 0%;
  vertical-align: bottom;
  text-transform: uppercase;
  margin-bottom: 3px;
}

.quantity-selector {
  display: flex;
  justify-content: center;
  align-items: center;
  border: 1px solid #9E5F2C;
  border-radius: 6px;
  width: -moz-fit-content;
  width: fit-content;
  background: transparent;
  z-index: 999;
}
.quantity-selector ion-icon {
  margin: 0px 10px;
  cursor: pointer;
}
.quantity-selector .quantity {
  width: 30px;
  height: 30px;
  font-family: AppFontBold;
  border-left: 1px solid #9E5F2C;
  border-right: 1px solid #9E5F2C;
  font-size: 15px;
  line-height: 85%;
  letter-spacing: 0%;
  text-align: center;
  vertical-align: middle;
  text-transform: capitalize;
  display: flex;
  align-items: center;
  justify-content: center;
}
.quantity-selector .quantity-btn {
  width: 9px;
  height: 11px;
}
.quantity-selector .quantity-btn.add-opacity {
  opacity: 0.5;
}

.items-block {
  display: flex;
  align-items: center;
  justify-content: right;
}
.items-block .circle-quantity {
  width: 25px;
  height: 25px;
  border: 1px solid var(--color-black);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 10px;
}

.paddig-top {
  padding-top: 10px;
}

.flex-end {
  justify-content: flex-end;
}

.note {
  font-size: 14px;
  word-wrap: break-word;
  word-break: break-word;
}`, "",{"version":3,"sources":["webpack://./src/app/components/order-list/order-list.component.scss"],"names":[],"mappings":"AAEA;EACC,cAAA;EACA,WAAA;AADD;AAEC;EACC,mBAAA;AAAF;;AAIA;EACC,WAAA;EAEA,gCAAA;EACA,uBAAA;AAFD;AAIC;EACC,gBAAA;EACA,iBAAA;AAFF;AAGE;EACC,WAAA;EACA,YAAA;AADH;AAGG;EACC,aAAA;EACA,gCAAA;AADJ;AAIE;EACC,mBAAA;EACA,UAAA;EACA,WAAA;EACA,cAAA;AAFH;AAKC;EACC,uBAAA;AAHF;AAKC;EACC,mBAAA;AAHF;AAKC;EACC,cAAA;EACA,+BAAA;EACA,eAAA;EACA,iBAAA;EACA,kBAAA;EACA,sBAAA;AAHF;AAOC;EACC,wBAAA;EACA,eAAA;EACA,iBAAA;EACA,sBAAA;EACA,sBAAA;EACA,yBAAA;AALF;AAQE;EACC,YAAA;EACA,aAAA;EACA,sBAAA;EACA,8BAAA;EACA,iBAAA;AANH;;AAUA;EACC,YAAA;EACA,aAAA;EACA,sBAAA;EACA,8BAAA;AAPD;;AAUA;EACC,aAAA;EACA,yBAAA;EACA,mBAAA;AAPD;AASC;EACC,YAAA;EACA,WAAA;EACA,eAAA;EACA,eAAA;AAPF;;AAWA;EACC,gBAAA;AARD;;AAUA;EACC,aAAA;EACA,mBAAA;AAPD;;AASA;EACC,wBAAA;EACA,eAAA;EACA,iBAAA;EACA,kBAAA;EACA,sBAAA;EACA,yBAAA;EACA,kBAAA;AAND;;AAQA;EACC,oBAAA;EACA,eAAA;EACA,iBAAA;EACA,kBAAA;EACA,sBAAA;EACA,yBAAA;EACA,kBAAA;AALD;;AAQA;EACC,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,yBAAA;EACA,kBAAA;EACA,uBAAA;EAAA,kBAAA;EACA,uBAAA;EAMA,YAAA;AAVD;AAMC;EACC,gBAAA;EACA,eAAA;AAJF;AAOC;EACC,WAAA;EACA,YAAA;EACA,wBAAA;EACA,8BAAA;EACA,+BAAA;EACA,eAAA;EACA,gBAAA;EACA,kBAAA;EACA,kBAAA;EACA,sBAAA;EACA,0BAAA;EAEA,aAAA;EACA,mBAAA;EACA,uBAAA;AANF;AAQC;EACC,UAAA;EACA,YAAA;AANF;AAOE;EACC,YAAA;AALH;;AASA;EACC,aAAA;EACA,mBAAA;EACA,sBAAA;AAND;AAOC;EACC,WAAA;EACA,YAAA;EACA,oCAAA;EACA,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,kBAAA;AALF;;AAQA;EACC,iBAAA;AALD;;AAOA;EACC,yBAAA;AAJD;;AAMA;EACC,eAAA;EACA,qBAAA;EACA,sBAAA;AAHD","sourcesContent":["@import '../../../theme/mixins';\n\n:host {\n\tdisplay: block;\n\twidth: 100%;\n\t&:not(:last-child) {\n\t\tmargin-bottom: 10px;\n\t}\n}\n\n.order-item {\n\twidth: 100%;\n\n\tborder-bottom: 1px solid #DCE8F5;\n\tpadding: 14px 14px 20px;\n\n\t.img_section {\n\t\tmin-height: 75px;\n\t\tmax-height: 100px;\n\t\t.img_wrap {\n\t\t\twidth: 100%;\n\t\t\theight: 100%;\n\n\t\t\t&:has(.default-img) {\n\t\t\t\tpadding: 18px;\n\t\t\t\t--icon-color: var(--color-black);\n\t\t\t}\n\t\t}\n\t\tion-img {\n\t\t\tobject-fit: contain;\n\t\t\twidth: 90%;\n\t\t\theight: 90%;\n\t\t\tmargin: 0 auto;\n\t\t}\n\t}\n\tion-col {\n\t\tpadding: 0px !important;\n\t}\n\t.name-row {\n\t\tmargin-bottom: 10px;\n\t}\n\t.order-article-name {\n\t\tcolor: #072633;\n\t\tfont-family: BricolageGrotesque;\n\t\tfont-size: 16px;\n\t\tline-height: 100%;\n\t\tletter-spacing: 2%;\n\t\tvertical-align: middle;\n\t\t// text-transform: uppercase;\n\t}\n\n\t.article-price {\n\t\tfont-family: AppFontBold;\n\t\tfont-size: 16px;\n\t\tline-height: 120%;\n\t\tletter-spacing: 0.02em;\n\t\tvertical-align: middle;\n\t\ttext-transform: uppercase;\n\t}\n\t.info-article-section {\n\t\t.article-content {\n\t\t\theight: 100%;\n\t\t\tdisplay: flex;\n\t\t\tflex-direction: column;\n\t\t\tjustify-content: space-between;\n\t\t\tpadding: 0px 10px;\n\t\t}\n\t}\n}\n.icons_block {\n\theight: 100%;\n\tdisplay: flex;\n\tflex-direction: column;\n\tjustify-content: space-between;\n}\n\n.edit_section {\n\tdisplay: flex;\n\tjustify-content: flex-end;\n\talign-items: center;\n\n\tion-icon {\n\t\theight: 15px;\n\t\twidth: 15px;\n\t\tmargin: 0px 4px;\n\t\tcursor: pointer;\n\t}\n}\n\n.flex-text {\n\tmin-height: 30px;\n}\n.center-vertical {\n\tdisplay: flex;\n\talign-items: center;\n}\n.option-group-name {\n\tfont-family: AppFontBold;\n\tfont-size: 10px;\n\tline-height: 120%;\n\tletter-spacing: 8%;\n\tvertical-align: middle;\n\ttext-transform: uppercase;\n\tmargin-bottom: 5px;\n}\n.option-name {\n\tfont-family: AppFont;\n\tfont-size: 10px;\n\tline-height: 120%;\n\tletter-spacing: 0%;\n\tvertical-align: bottom;\n\ttext-transform: uppercase;\n\tmargin-bottom: 3px;\n}\n\n.quantity-selector {\n\tdisplay: flex;\n\tjustify-content: center;\n\talign-items: center;\n\tborder: 1px solid #9E5F2C;\n\tborder-radius: 6px;\n\twidth: fit-content;\n\tbackground: transparent;\n\n\tion-icon {\n\t\tmargin: 0px 10px;\n\t\tcursor: pointer;\n\t}\n\tz-index: 999;\n\t.quantity {\n\t\twidth: 30px;\n\t\theight: 30px;\n\t\tfont-family: AppFontBold;\n\t\tborder-left: 1px solid #9E5F2C;\n\t\tborder-right: 1px solid #9E5F2C;\n\t\tfont-size: 15px;\n\t\tline-height: 85%;\n\t\tletter-spacing: 0%;\n\t\ttext-align: center;\n\t\tvertical-align: middle;\n\t\ttext-transform: capitalize;\n\n\t\tdisplay: flex;\n\t\talign-items: center;\n\t\tjustify-content: center;\n\t}\n\t.quantity-btn {\n\t\twidth: 9px;\n\t\theight: 11px;\n\t\t&.add-opacity {\n\t\t\topacity: 0.5;\n\t\t}\n\t}\n}\n.items-block {\n\tdisplay: flex;\n\talign-items: center;\n\tjustify-content: right;\n\t.circle-quantity {\n\t\twidth: 25px;\n\t\theight: 25px;\n\t\tborder: 1px solid var(--color-black);\n\t\tborder-radius: 50%;\n\t\tdisplay: flex;\n\t\talign-items: center;\n\t\tjustify-content: center;\n\t\tmargin-right: 10px;\n\t}\n}\n.paddig-top {\n\tpadding-top: 10px;\n}\n.flex-end {\n\tjustify-content: flex-end;\n}\n.note {\n\tfont-size: 14px;\n\tword-wrap: break-word;\n\tword-break: break-word;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
